import script from "./ArticlesMolecule.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesMolecule.vue?vue&type=script&setup=true&lang=js"

import "./ArticlesMolecule.vue?vue&type=style&index=0&id=1520f651&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1520f651"]])

export default __exports__